<template>
  <div style="display: flex;flex-wrap: wrap">
    <el-card class="card">
      <div class="iconfont icon-read"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">单页数量：{{ data.page }}</div>
      </div>
    </el-card>
    <el-card class="card">
      <div class="iconfont icon-people"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">单页推广人数：{{ data.page_share }}</div>
      </div>
    </el-card>
    <el-card class="card">
      <div class="iconfont icon-read1"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">电子书数量：{{ data.ebook }}</div>
      </div>
    </el-card>
    <el-card class="card">
      <div class="iconfont icon-people"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">电子书推广人数：{{ data.ebook_share }}</div>
      </div>
    </el-card>
    <el-card class="card">
      <div class="iconfont icon-pay"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">充值记录：{{ data.recharge }}</div>
      </div>
    </el-card>
    <el-card class="card">
      <div class="iconfont icon-pay"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">分配记录：{{ data.send }}</div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
name: "index_user",
  data(){
    return{
      data:{
        'page_share':0,
        'ebook_share':0,
        'page':0,
        'ebook':0,
        'recharge':0,
        'send':0,
      }
    }
  },
  mounted() {
    try {
      this.getinfo()
    }catch (e) {
      console.log(e)
    }
  },
  methods:{
    getinfo:async function (){
      let that = this;
      this.$_showLoading();
      let res = await that.$_api.company('get_info',{uid:this.user.uid});
      if(res.errcode == 0){
        this.data = res.data;
      }
      this.$_hideLoading();
    }
  }
}
</script>

<style scoped>
.card{
  width: 320px;
  text-align: center;
  margin: 40px;
}
.iconfont{
  font-size: 100px;
  color: #666;
  padding: 20px;
}
</style>